import { ApiResponse, ApisauceInstance, create } from 'apisauce'
import { ApiConfig, DEFAULT_API_CONFIG } from './api-config'
import { getGeneralApiProblem } from './api-problem'
import { IStore } from '../../app/store'

export interface IApi {
  apiSauce: ApisauceInstance
  config: ApiConfig
  // get: <TApiResponseModel>(apiPath: string, params?: any) => Promise<TApiResponseModel>
  // post: <TApiResponseModel>(apiPath: string, params?: any) => Promise<TApiResponseModel>
  // put: <TApiResponseModel>(apiPath: string, params?: any) => Promise<TApiResponseModel>
  // delete: <TApiResponseModel>(apiPath: string, params?: any) => Promise<TApiResponseModel>
  // handleAPIFailure: (response: ApiResponse<unknown, unknown>) => null
  // handleAPIResult: <TApiResponseModel> (response: ApiResponse<unknown, unknown>) => TApiResponseModel
  // parseAPIResultIntoModel: <TApiResponseModel>(response: ApiResponse<unknown, unknown>) => TApiResponseModel
}

export class APIError extends Error {
  response: any
}

export class Api implements IApi {
  apiSauce: ApisauceInstance
  config: ApiConfig

  constructor (store: IStore) {
    this.config = DEFAULT_API_CONFIG
    this.apiSauce = create({
      baseURL: this.config.url,
      headers: {
        Accept: 'application/json'
      }
    })
    // this.authRepo = new AuthRepository(store)
    // this.apiSauce.addRequestTransform((request) => {
    //   const token = this.authRepo.getAuthToken()
    //   if (token !== undefined && token !== '') {
    //     request.headers.Authorization = `Token ${token}`
    //   }
    // })
  }

  protected handleAPIFailure (response: ApiResponse<unknown, unknown>): null {
    const problem = getGeneralApiProblem(response)
    const apiError = new APIError(problem?.kind)
    apiError.response = response.data
    throw apiError
  }

  protected handleAPIResult<TApiResponseModel>(
    response: ApiResponse<unknown, unknown>
  ): TApiResponseModel {
    return response.data as TApiResponseModel
  }

  protected parseAPIResultIntoModel<TApiResponseModel>(
    response: ApiResponse<unknown, unknown>
  ): TApiResponseModel {
    if (response.ok) {
      return this.handleAPIResult<TApiResponseModel>(response)
    } else {
      this.handleAPIFailure(response)
      return this.handleAPIResult<TApiResponseModel>(response)
    }
  }

  protected async delete<TApiResponseModel>(
    apiPath: string,
    params?: any
  ): Promise<TApiResponseModel> {
    const result = await this.apiSauce.delete(apiPath, params)
    return this.parseAPIResultIntoModel<TApiResponseModel>(result)
  }

  protected async get<TApiResponseModel>(
    apiPath: string,
    params?: any
  ): Promise<TApiResponseModel> {
    const result = await this.apiSauce.get(apiPath, params)
    return this.parseAPIResultIntoModel<TApiResponseModel>(result)
  }

  protected async post<TApiResponseModel>(
    apiPath: string,
    params?: any,
    headers?: any
  ): Promise<TApiResponseModel> {
    const result = await this.apiSauce.post(apiPath, params)
    return this.parseAPIResultIntoModel<TApiResponseModel>(result)
  }

  protected async put<TApiResponseModel>(
    apiPath: string,
    params?: any
  ): Promise<TApiResponseModel> {
    const result = await this.apiSauce.put(apiPath, params)
    return this.parseAPIResultIntoModel<TApiResponseModel>(result)
  }

  protected async patch<TApiResponseModel>(
    apiPath: string,
    params?: any
  ): Promise<TApiResponseModel> {
    const result = await this.apiSauce.patch(apiPath, params)
    return this.parseAPIResultIntoModel<TApiResponseModel>(result)
  }
}
